import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[autofocus]',
})
export class AutofocusDirective {
  @Input('autofocus') options: { focus: boolean } = { focus: true };

  constructor(private host: ElementRef) {}

  ngAfterViewInit() {
    if (this.options.focus) {
      this.host.nativeElement.focus();
    }
  }
}
